import Web3 from "web3";

//监听钱包是否取消连接
function disconnect() {
  window.ethereum.on("disconnect", (accounts) => {
    console.log("取消链接", accounts);
    this.$toast.fail("取消链接");
  });
}

//链接钱包以及监听钱包
function ConnectWallet() {
  return new Promise((resolve, reject) => {
    if (window.ethereum) {
      window.ethereum
        .request({
          method: "eth_requestAccounts",
        })
        .then((res) => {
          console.log("进", res);
          this.$ls.set("WalletAddress", res);

          // 在这里可以执行任何你需要在账户变化时进行的操作
          window.ethereum.on("accountsChanged", (accounts) => {
            this.$ls.set("WalletAddress", accounts);
            window.location.reload();
            console.log("Account changed:", accounts[0]);
          });
          resolve(res);
        })
        .catch((error) => {
          this.$toast.fail(error.message);
          reject("Please install your wallet");
        });
    } else {
      reject("Please install your wallet");
    }
  });
}

//监听钱包是否变化
function monitorWallet() {
  if (window.ethereum) {
    window.ethereum.on("accountsChanged", (accounts) => {
      this.$ls.set("WalletAddress", accounts);
      window.location.reload();
      console.log("Account changed:", accounts[0]);
    });
  }
}
//判断是否为科学计数法
function isScientificNotation(str) {
  // 科学计数法的正则表达式
  const scientificPattern = /^[-+]?[0-9]*\.?[0-9]+([eE][-+]?[0-9]+)$/;

  // 使用正则表达式进行匹配判断
  return scientificPattern.test(str);
}
//将科学计数法的数字转换为正常的小数
function convertScientificToNormal(scientificNum) {
  return Number(scientificNum)
    .toFixed(20)
    .replace(/\.?0+$/, "");
}
/**
 *
 * @param {*} num 传入转换的数字
 * valueToRound 是否整数末尾加.00
 * @returns //返回俩位数字符串数字
 */
function toFixedTwo(num, valueToRound) {
  if (isScientificNotation(num)) {
    num = convertScientificToNormal(num);
    console.log("是科学计数法", convertScientificToNormal(num));
  } else {
    num = num.toString();
  }
  let parts = num.split(".");
  if (parts.length > 1) {
    if (num.toString().length < 4) {
      for (let i = 0; i < 4 - num.toString().length; i++) {
        num = num + "0";
      }
    } else {
      parts[1] = parts[1].slice(0, 2);
      num = parts[0] + "." + parts[1];
    }
  } else {
    num = valueToRound ? num + ".00" : num;
  }
  return num;
}
//获取当前时间（毫秒数）英国伦敦时间
function getCurrenLondonTime() {
  const chinaStandardTimeOffset = new Date().getTime() - 7 * 60 * 60 * 1000;
  return chinaStandardTimeOffset;
}
//工具函数把小时字符串转换为时间戳（毫秒数）
function convertHoursToTimestamp(hoursStr) {
  // 将12小时转换为毫秒数
  const milliseconds = hoursStr * 60 * 60 * 1000;
  return milliseconds;
}
//工具函数把天数字符串转换为时间戳
function convertDaysToTimestamp(daysStr) {
  // 提取天数部分并转换为数字
  const days = parseInt(daysStr);

  // 计算天数对应的毫秒数
  const milliseconds = days * 24 * 60 * 60 * 1000;

  return milliseconds;
}
//工具函数把时间戳转换为国际格式日期
function convertTimestampToInternationalDate(timestamp) {
  const date = new Date(timestamp);

  // 使用 Intl.DateTimeFormat 格式化日期为指定格式
  const customDate = new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);

  return customDate.replace(" PM", "").replace(" AM", "");
}
//工具函数把标准日期格式转为时间戳（毫秒数）
function convertStandardDateToTimestamp(time) {
  const date = new Date(time);

  // 获取时间戳（毫秒数）
  const timestamp = date.getTime();
  return timestamp;
}
//工具函数把时间戳转为标准日期格式（毫秒数）
function convertTimestampToStandardDate(timestamp) {
  const date = new Date(timestamp);
  const options = {
    weekday: "short",
    month: "short",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    timeZoneName: "short",
  };
  const formattedDate = date.toLocaleString("en-US", options);
  return formattedDate;
}

export {
  ConnectWallet,
  disconnect,
  monitorWallet,
  toFixedTwo,
  convertHoursToTimestamp,
  convertDaysToTimestamp,
  convertTimestampToInternationalDate,
  convertStandardDateToTimestamp,
  convertTimestampToStandardDate,
  getCurrenLondonTime,
};
